import DevicePickerService from './device_picker_service.js';
import { KeyboardNavigation } from './keyboard_navigation.js';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

const nav = new KeyboardNavigation({
   keys: {
      '/': deviceNavigator,
   },
});

export default function deviceNavigator(options = null) {
   trackInMatomoAndGA({
      eventCategory: 'Category',
      eventAction: 'Device Navigator',
   });
   if (!options) {
      options = {
         initialView: 'COLUMN',
      };
   }
   DevicePickerService.selectDevice(options).then(device => {
      if (device) {
         const encodedTitle = DevicePickerService.encodeDeviceTitle(device);
         window.location = `/Device/${encodedTitle}`;
      }
   });
}
